@if (mode === 'renderer') {
  <div
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-right.px': element.fields.marginRight,
      'margin-bottom.px': element.fields.marginBottom,
      'margin-left.px': element.fields.marginLeft,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft
    }"
  >
    @if (element.fields.title) {
      <h3>{{ element.fields.title | translate }}</h3>
    }

    @if (loading) {
      <div class="text-center p-3">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    } @else if (offers.length === 0) {
      <p class="text-muted">{{ element.fields.emptyText | translate }}</p>
    } @else {
      <div class="offer-list">
        @for (offer of offers; track offer.id) {
          <div class="offer-item d-flex align-items-center justify-content-between p-3 mb-2 border rounded">
            <div>
              <div class="fw-bold">{{ offer.id }}</div>
              @if (offerDate(offer)) {
                <small class="text-muted">{{ offer.extra?.gungSalesOrder?.orderDate | date: 'yyyy-MM-dd' }}</small>
              }
            </div>
            <button
              type="button"
              class="dc-pill-btn"
              [style.--dc-btn-bg]="element.fields.buttonBackground"
              [style.--dc-btn-color]="element.fields.buttonColor"
              [style.--dc-btn-hover-bg]="element.fields.buttonHoverBackground || element.fields.buttonBackground"
              [style.--dc-btn-hover-color]="element.fields.buttonHoverColor || element.fields.buttonColor"
              [style.--dc-btn-radius.px]="element.fields.buttonBorderRadius"
              [style.font-size.px]="element.fields.buttonFontSize"
              (click)="openOffer(offer)"
            >
              {{ element.fields.buttonText | translate }}
            </button>
          </div>
        }
      </div>
    }
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title"><span>Content</span></div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12 mb-2">
              <lib-gung-text-input [gungTranslate]="'Title'" [(ngModel)]="element.fields.title"></lib-gung-text-input>
            </div>
            <div class="col-12 mb-2">
              <label>Number of offers to show</label>
              <input class="form-control" type="number" min="1" [(ngModel)]="element.fields.limit" />
            </div>
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Button text'"
                [(ngModel)]="element.fields.buttonText"
              ></lib-gung-text-input>
            </div>
            <div class="col-12 mb-2">
              <lib-gung-text-input
                [gungTranslate]="'Empty state text'"
                [(ngModel)]="element.fields.emptyText"
              ></lib-gung-text-input>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title"><span>Styles</span></div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-6 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input [gungTranslate]="'Button background'" [(ngModel)]="element.fields.buttonBackground"></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.buttonBackground" />
              </div>
            </div>
            <div class="col-6 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input [gungTranslate]="'Button text color'" [(ngModel)]="element.fields.buttonColor"></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.buttonColor" />
              </div>
            </div>
            <div class="col-6 mb-2">
              <label>Button border radius</label>
              <input class="form-control" type="number" min="0" [(ngModel)]="element.fields.buttonBorderRadius" />
            </div>
            <div class="col-6 mb-2">
              <label>Button font size</label>
              <input class="form-control" type="number" min="8" [(ngModel)]="element.fields.buttonFontSize" />
            </div>
          </div>
          <lib-dynamic-page-element-margin-padding
            [(marginTop)]="element.fields.marginTop"
            [(marginRight)]="element.fields.marginRight"
            [(marginBottom)]="element.fields.marginBottom"
            [(marginLeft)]="element.fields.marginLeft"
            [(paddingTop)]="element.fields.paddingTop"
            [(paddingRight)]="element.fields.paddingRight"
            [(paddingBottom)]="element.fields.paddingBottom"
            [(paddingLeft)]="element.fields.paddingLeft"
          ></lib-dynamic-page-element-margin-padding>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="preview-card-info d-flex align-items-center justify-content-center">
    <i class="fa-solid fa-receipt"></i>
  </div>
}
